import {OutsourcedStatics} from "../../config/OutsourcedStatics";
import {gsap} from "gsap";
import {OutsourcedGameAssets} from "../../OutsourcedGameAssets";
import {Outsourced} from "../../Outsourced";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {OutsourcedSymbol, SymbolArgs} from "./OutsourcedSymbol";

export class XNudgeSymbol extends OutsourcedSymbol {
    public multiplier:PIXI.Sprite;
    public spine:PIXI.spine.Spine;

    constructor(args:SymbolArgs) {
        super(args);
        this.multiplier = new PIXI.Sprite(Outsourced.assetLoader.getTextures("XN_Multiplier/X_1")[0])
        this.multiplier.scale.set(0.9, 0.9);
        this.multiplier.anchor.set(0.5, 0.5);
        this.addChild(this.multiplier);
    }

    public expand(startIndex:number): gsap.core.Timeline {

        this.spine = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.X_NUDGE_SPINE));
        this.spine.position.y = 148 * (1.5 - startIndex);
        this.addChild(this.spine);
        this.removeChild(this.multiplier);
        this.addChild(this.multiplier);

        const multiplier1 = this.multiplier;
        const multiplier2 = new PIXI.Sprite(Outsourced.assetLoader.getTextures("XN_Multiplier/X_2")[0]);
        multiplier2.anchor.set(0.5, 0.5);
        multiplier2.scale.set(1.2, 1.2);
        const multiplier3 = new PIXI.Sprite(Outsourced.assetLoader.getTextures("XN_Multiplier/X_3")[0]);
        multiplier3.anchor.set(0.5, 0.5);
        multiplier3.scale.set(1.1 * 1.2, 1.1 * 1.2);
        const multiplier4 = new PIXI.Sprite(Outsourced.assetLoader.getTextures("XN_Multiplier/X_4")[0]);
        multiplier4.anchor.set(0.5, 0.5);
        multiplier4.scale.set(1.2 * 1.2, 1.2 * 1.2);

        return gsap.timeline()
            .add(gsap.to(multiplier1, {x: 1.2, y: 1.2, duration: 0.1, ease: "power3.out"}))
            .add(() => {
                this.removeChild(multiplier1);
                this.multiplier = multiplier2
                this.addChild(multiplier2);
            })
            .add(gsap.to(multiplier2.scale, {x: 1, y: 1, duration: 0.1, ease: "power3.in"}))

            .add(gsap.to(multiplier2, {x: 1.1 * 1.2, y: 1.1 * 1.2, duration: 0.1, ease: "power3.out"}), '>0.23')
            .add(() => {
                this.removeChild(multiplier2);
                this.multiplier = multiplier3
                this.addChild(multiplier3);
            })
            .add(gsap.to(multiplier3.scale, {x: 1.1, y: 1.1, duration: 0.1, ease: "power3.in"}))

            .add(gsap.to(multiplier3, {x: 1.2 * 1.2, y: 1.2 * 1.2, duration: 0.1, ease: "power3.out"}), '>0.23')
            .add(() => {
                this.removeChild(multiplier3);
                this.multiplier = multiplier4
                this.addChild(multiplier4);
            })
            .add(gsap.to(multiplier4.scale, {x: 1.2, y: 1.2, duration: 0.1, ease: "power3.in"}))
            .add(SpineGSAPWrapper.createTimeline(this.spine, 0, `XN_Expand_${startIndex + 1}`), 0)
            .add(() => {
                this.spine.state.setEmptyAnimation(0, 0)
                this.spine.alpha = 0;
            })
    }

    public hideMultiplier() {
        this.multiplier.visible = false;
    }
}